import { initDevice } from './modules/devicesHandler.js';
import { padLeft, selectSetColor, reloadImg } from './modules/common.js';
import { More } from './modules/components.js';
import { marqueeHandler } from './modules/marquee.js';
import './modules/checkAnchor.js';
import './about.js';


initDevice();





const easeOutQuart = (x) => {
	return 1 - Math.pow(1 - x, 4);
};

let lenis = null

function initLenis() {
	lenis = new Lenis({
		// duration: 1.0,
		// easing: easeOutQuart,
		wheelMultiplier: 1,
	})

	// 好像推薦開 但我覺得不開比較順…?
	// lenis.on("scroll", ScrollTrigger.update);

	const raf = (time) => {
		if (lenis) {
			lenis.raf(time)
			requestAnimationFrame(raf)
		}
	}

	requestAnimationFrame(raf)
}

const page = document.body.dataset.page || ''

if (page !== 'home' || device != 'mobile') {
	initLenis()
}






$("#preload").delay(200).fadeOut(500)



// 解決 safari hitory.back() reload 問題
$(window).on("pageshow", function(event) {
	if (event.originalEvent.persisted) {
		window.location.reload()
	}
});








// 選單下滑隱藏 快滾回去時消失
let _scrollLast = 0

$(window).on("scroll", () => {
	let _scrollTop = $(window).scrollTop()
	let _allBottom = $("body").height() - $(window).height() - 100

	if (_scrollTop < 0 || _scrollTop > _allBottom) {
		return false;
	}

	if (_scrollTop > 200) {
		if (_scrollTop > _scrollLast) {
			$("#fixed-bg, #fixed-logo, #fixed-hamburger").removeClass("is-visible")
			$("#topmenuWrap").removeClass("is-fixed")
		} else {
			$("#fixed-bg, #fixed-logo, #fixed-hamburger").addClass("is-visible")
			$("#topmenuWrap").addClass("is-fixed")
		}
	} else {
		$("#fixed-bg, #fixed-logo, #fixed-hamburger").removeClass("is-visible")
		$("#topmenuWrap").removeClass("is-fixed")
	}

	_scrollLast = _scrollTop
}).trigger("scroll")









$(".backtotop").on("click", function() {
	gsap.to(window, {
		duration: 1.2,
		scrollTo: 0,
		ease: 'power2.inOut',
	});
})




$(".hamburger").on("click", function() {
	$(this).toggleClass("is-show")
	$("#topmenuWrap").toggleClass("is-show")
})






function mobileMenuHandler(el) {
	$(el).children().each(function(i, item) {
		$(this).on("click", function() {
			$(this).toggleClass("is-open")
			$(".submenuWrap", this).slideToggle(300)
		})
	})
}








function ryderParallax() {
	if (page == 'home') {
		return false
	}

	$("[data-dist]").each(function(i, el) {
		const elHeight = el.clientHeight;
		let dataScale = 1.2;
		let moveDistPer = 20;

		let _r = (device != 'mobile') ? Number(el.dataset.dist) : Number(el.dataset.dist) * 0.6;
		let startPosition = -(_r * moveDistPer);
		let endPosition = (_r * moveDistPer) / 2;

		gsap.set(el, {
			scale: dataScale,
		});

		gsap.fromTo(el, {
			yPercent: startPosition
		}, {
			yPercent: endPosition,
			ease: 'sine.out',
			scrollTrigger: {
				trigger: el,
				start: `top+=${elHeight * 0.2} bottom`,
				end: `bottom+=${elHeight * 0.5} top`,
				scrub: true,
			},
		}
		);
	});
}




function ryderEnter() {
	if (page == 'home') {
		return false
	}
	$("[data-enter]").each((i, el) => {
		let customOffset = $(el).data('enter') || 0.3;

		let ob_offset = $(window).height() * -customOffset;
		let ob_offset_w = $(window).width() * -customOffset;

		let observer = new IntersectionObserver(function(entries, observer) {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.classList.add('is-enter');
				} else {
					if (!$(entry.target).hasClass('enter-once')) {
						entry.target.classList.remove('is-enter');
					}
				}
			});
		}, {
			root: null,
			rootMargin: `40px ${ob_offset_w}px ${ob_offset}px 0px`,
			threshold: 0
		});

		observer.observe(el);
	});
}


gsap.delayedCall(0.5, () => {
	ryderEnter()
});


$(window).on("load", function() {
	ryderEnter()
	ryderParallax()
})







// 批量掛載到 window
const globals = {
	padLeft,
	mobileMenuHandler,
	selectSetColor,
	reloadImg,
	More,
	marqueeHandler,
};

Object.assign(window, globals);